import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component({})
export default class MergeHeader  extends Vue {
    @Prop({ type: Array }) resourceList!: reserve.ResourceItemBase[];         

    getColorClass(resource: reserve.ResourceItemBase): { [key: string]: boolean } {
        let classObj: { [key: string]: boolean } = {};
        classObj[resource.colorCode] = true;
        return classObj;
    }
}